import { Editor } from "slate";

import { isValidUrl } from "@mapmycustomers/shared/util/url";

import insertLink from "./insertLink";
const withLinks = (editor: Editor) => {
  const { insertData } = editor;

  editor.insertData = (data: DataTransfer) => {
    const text = data.getData("text/plain");

    if (isValidUrl(text)) {
      insertLink(editor, text);
    } else {
      insertData(data);
    }
  };

  return editor;
};

export default withLinks;
